export default __webpack_public_path__ + "static/media/basket.21f967d2.jpg";